import { render, staticRenderFns } from "./changePrice.vue?vue&type=template&id=11516d68&scoped=true&"
import script from "./changePrice.vue?vue&type=script&lang=js&"
export * from "./changePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11516d68",
  null
  
)

export default component.exports